import React from 'react';

const OCHA_BASE_URL = 'https://raw.githubusercontent.com/rodekruis/OCHA-Humanitarian-Icons/main';

const OchaIcon = ({ name, size = 36, color = 'white', style = {} }) => {
    const folder = color === 'white' ? 'white' : 'svg';
    const src = `${OCHA_BASE_URL}/${folder}/${name}.svg`;

    return (
        <img
            src={src}
            alt={name}
            width={size}
            height={size}
            style={{ display: 'inline-block', ...style }}
        />
    );
};

export default OchaIcon;
